import { createFileRoute } from '@tanstack/react-router'
import { Container } from '@/components/ui/Container'
import { Section } from '@/components/ui/Section'
import { siteConfig } from '@/config/site'

export const Route = createFileRoute('/privacy')({
  component: PrivacyPage,
})

function PrivacyPage() {
  return (
    <Section surface="0" className="pt-10 pb-16 sm:pt-16 sm:pb-24 md:pt-20 md:pb-28">
      <Container className="max-w-3xl">
        <span className="font-mono text-xs uppercase tracking-widest text-fg-muted mb-3 sm:mb-4 block">
          Governance & Compliance
        </span>
        <h1 className="text-2xl sm:text-4xl font-bold tracking-tight text-fg mb-6 sm:mb-8">
          Privacy Policy
        </h1>

        <div className="space-y-4 sm:space-y-6 text-sm text-fg-subtle leading-relaxed">
          <p>
            Last Updated: September 2025
          </p>

          <h2 className="text-lg font-semibold text-fg pt-4">
            1. Information We Collect
          </h2>
          <p>
            {siteConfig.name} collects information that you voluntarily transmit to us via our project specification forms, contact channels, or direct correspondence. This includes your name, email address, company affiliation, and project requirements.
          </p>

          <h2 className="text-lg font-semibold text-fg pt-4">
            2. Purpose of Processing
          </h2>
          <p>
            We process technical and contact inquiries strictly for evaluating scopes of work, responding to requests for proposals (RFPs), and executing contracted software development services. We never sell, rent, or distribute your information to third-party advertisers.
          </p>

          <h2 className="text-lg font-semibold text-fg pt-4">
            3. Security & Infrastructure
          </h2>
          <p>
            Transmissions are protected using enterprise-grade TLS encryption, Cloudflare WAF, and automated threat prevention. Access to client communications is restricted exclusively to authorized engineering personnel.
          </p>

          <h2 className="text-lg font-semibold text-fg pt-4">
            4. Inquiries & Data Rights
          </h2>
          <p>
            To request the review or deletion of your project correspondence, contact our data administration desk at{' '}
            <a href={`mailto:${siteConfig.email}`} className="text-fg underline underline-offset-4">
              {siteConfig.email}
            </a>.
          </p>
        </div>
      </Container>
    </Section>
  )
}
